"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1887],{

/***/ 51887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);



var FootPrintBlogs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(7758)]).then(__webpack_require__.bind(__webpack_require__, 28020));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28020)
            ];
        }
    }
});
var MeetTeamCard = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(486)]).then(__webpack_require__.bind(__webpack_require__, 90486));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90486)
            ];
        }
    }
});
var BlogsWithLoadMore = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(3632)]).then(__webpack_require__.bind(__webpack_require__, 46235));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46235)
            ];
        }
    }
});
var PassionateCard = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(6019)]).then(__webpack_require__.bind(__webpack_require__, 46019));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46019)
            ];
        }
    }
});
var Community = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
    var coreValuesTitle = (ref2 = props === null || props === void 0 ? void 0 : (ref = props.communityData) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Section[2]) === null || ref2 === void 0 ? void 0 : ref2.Title;
    var coreValuesData = (ref5 = props === null || props === void 0 ? void 0 : (ref3 = props.communityData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.Section[3]) === null || ref5 === void 0 ? void 0 : ref5.Cards;
    var footPrintTitle = props === null || props === void 0 ? void 0 : (ref6 = props.communityData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.Section[4].Title;
    var communityTitle = props === null || props === void 0 ? void 0 : (ref8 = props.communityData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.attributes) === null || ref9 === void 0 ? void 0 : ref9.Section[5].Title;
    var meetTitle = props === null || props === void 0 ? void 0 : (ref10 = props.communityData) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.Section[6].Title;
    var meetTeamData = props === null || props === void 0 ? void 0 : (ref12 = props.communityData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : ref13.Section[7].Cards;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sv-page-content community-giving-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container-xl custom-container px-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "hero-section",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "hero-banner",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    sizes: "(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px",
                                    className: "banner-img",
                                    src: ((ref16 = props === null || props === void 0 ? void 0 : (ref14 = props.communityData) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.attributes) === null || ref15 === void 0 ? void 0 : ref15.Section[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.Background_Image) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.attributes) === null || ref19 === void 0 ? void 0 : ref19.url) || "",
                                    width: "1280",
                                    alt: ((ref22 = props === null || props === void 0 ? void 0 : (ref20 = props.communityData) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.attributes) === null || ref21 === void 0 ? void 0 : ref21.Section[0]) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.Background_Image) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.data) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.attributes) === null || ref25 === void 0 ? void 0 : ref25.alternativeText) || "",
                                    height: "516"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "banner-content",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "col-lg-12 col-md-12 col-sm-12 m-auto",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    children: (ref28 = props === null || props === void 0 ? void 0 : (ref26 = props.communityData) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.attributes) === null || ref27 === void 0 ? void 0 : ref27.Section[0]) === null || ref28 === void 0 ? void 0 : ref28.Title
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "promotion-banner",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: (ref31 = props === null || props === void 0 ? void 0 : (ref29 = props.communityData) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.attributes) === null || ref30 === void 0 ? void 0 : ref30.Section[1]) === null || ref31 === void 0 ? void 0 : ref31.Title
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PassionateCard, {
                coreValuesData: coreValuesData,
                coreValuesTitle: coreValuesTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FootPrintBlogs, {
                blogs: props.footprintBlogsData,
                title: footPrintTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogsWithLoadMore, {
                blogs: props.communityBlogsData,
                title: communityTitle,
                initSize: 6,
                loadMoreSize: 6
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MeetTeamCard, {
                meetTitle: meetTitle,
                meetTeamData: meetTeamData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Community);


/***/ })

}]);